import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

import auth from "./modules/auth";
import content from "./modules/content";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    pageTitle: "",
    overlay: true,
    collapse: false
  },
  getters,
  mutations,
  actions,
  modules: {
    auth,
    content
  },
  plugins: [createPersistedState()]
});
